/** Shared Tailwind class helpers for the Ions & Bonding Lab controls. */
export function choiceClass(selected: boolean): string {
  return `rounded-2xl border px-4 py-3 text-left text-sm font-extrabold transition-colors motion-reduce:transition-none ${
    selected ? 'border-brand-sky bg-wash-sky text-ink' : 'border-hairline bg-white text-slate2 hover:border-brand-sky/40'
  }`;
}

export function pillClass(selected: boolean): string {
  return `rounded-full border px-4 py-2 text-sm font-extrabold transition-colors motion-reduce:transition-none ${
    selected ? 'border-ink bg-ink text-white' : 'border-hairline bg-surface text-ink hover:border-brand-sky/40'
  }`;
}

export const primaryButtonClass =
  'inline-flex items-center gap-2 rounded-full bg-ink px-5 py-3 text-sm font-extrabold text-white disabled:cursor-not-allowed disabled:opacity-40';
